import { FC } from 'react';
import { isArray } from 'lodash-es';
import { Table } from '@chakra-ui/react';

import { isObject } from '../utils/general';
import { FieldToBlock, FieldValueProps } from './declarations';
import { renderFieldValue } from './FieldUtils';

export const RepeatedJsonFieldToBlock: FieldToBlock<'repeated_json'> = (
  field,
) => {
  throw new Error(`Not implemented for repeated_json field ${field.name}`);
};

type RepeatedJsonFieldValueProps = FieldValueProps<'repeated_json'>;

type FirstField = Exclude<
  RepeatedJsonFieldValueProps['field']['value'],
  null
>[number];

export const RepeatedJsonFieldValue: FC<RepeatedJsonFieldValueProps> = ({
  field,
}) => {
  const fieldArray = field.value;

  if (!isArray(fieldArray)) {
    return null;
  }

  const first = fieldArray[0];

  // TODO: @haxxxton > im not sure about this.. the type implies its an array of object, but isObject specifically excludes arrays
  // this is particularly weird as it would mean the later Object.values(first).map() is just the same as calling first.map() if it is an array
  if (!isObject<FirstField>(first)) {
    return null;
  }

  return (
    <Table.Root variant="simple">
      <Table.Header>
        <Table.Row>
          {Object.values(first).map((firstField, _) => (
            // eslint-disable-next-line react/no-array-index-key
            <Table.ColumnHeader key={_}>{firstField.label}</Table.ColumnHeader>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {fieldArray.map((fieldsObject, arrayIndex) => (
          // eslint-disable-next-line react/no-array-index-key
          <Table.Row key={arrayIndex}>
            {Object.values(fieldsObject).map((fieldItem, fieldIndex) => (
              // eslint-disable-next-line react/no-array-index-key
              <Table.Cell key={fieldIndex}>
                {renderFieldValue(fieldItem)}
              </Table.Cell>
            ))}
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  );
};
